import { IAccount } from "../../Models/Account";

export enum Actions {
	CHECKING_TOKEN = 'CHECKING_TOKEN',
	CHECKED_TOKEN = 'CHECKED_TOKEN',
	REQUEST_TOKEN = 'REQUEST_TOKEN',
	RESPONSE_TOKEN = 'RESPONSE_TOKEN',
	INIT_SESSION = 'INIT_SESSION',
	FETCH_FAENAS = 'FETCH_FAENAS',
	STATUS_SESSION = 'STATUS_SESSION',
	ERROR_SESSION = 'ERROR_SESSION'
}

export interface IActionRequest {
	type: Actions.REQUEST_TOKEN;
}

export interface IActionChecked {
	type: Actions.CHECKED_TOKEN;
	payload: IResponseAuth;
}

export interface IActionChecking {
	type: Actions.CHECKING_TOKEN;
}

export interface IResponseAuth {
	isAuth: boolean;
	token?: string;
	message: string;
}

export interface IActionResponse {
	type: Actions.RESPONSE_TOKEN;
	payload: IResponseAuth;
}

export interface IActionSession {
	type: Actions.INIT_SESSION;
	payload: IAccount;
}


export interface IActionFaenas {
	type: Actions.FETCH_FAENAS,
	payload: any[];
}
